import { configure, defineRule } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { Locale } from "vue-i18n";

import {
    maxLengthValidator,
    minLengthValidator,
    multipleValidator,
} from "@/functions/validators/selectValidators";

import getValidationResponse from "@/assets/validation";
import { all } from "@vee-validate/rules";
import en from "@vee-validate/i18n/dist/locale/en.json";
import de from "@vee-validate/i18n/dist/locale/de.json";

Object.keys(all).forEach((rule) => {
    if (rule in all) {
        defineRule(rule, all[rule]);
    }
});

defineRule("min_length", minLengthValidator);
defineRule("max_length", maxLengthValidator);
defineRule("multiple", multipleValidator);

const loadLocale = async (code: Locale): Promise<void> => {
    localize({ en, de });

    configure({
        generateMessage: localize(code, {
            messages: {
                min_length: getValidationResponse(code, "min_length"),
                max_length: getValidationResponse(code, "max_length"),
                multiple: getValidationResponse(code, "multiple"),
            },
        }),
    });
};

export default loadLocale;
